
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material'
import toast from "react-hot-toast";

import ProgramVideo from "./ProgramVideo";
import ProgramEquipments from "./ProgramEquipments";
import ProgramDescription from "./ProgramDescription";

import LoadingAnimation from "../../common/LoadingAnimation";
import LoadingAnimation2 from "../../common/LoadingAnimation2";
import PaddedContentArea from "../../common/PaddedContentArea";

import { FaPlus } from "react-icons/fa";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { Dumbbell } from "../../common/CustomIcons";

import { AddProgram, GetAllWorkOutHistories, GetAllWorkOutHistoriesWithArchived, GetSelectionHistory, } from "../../redux/v2/user/actions";
import { GetPrograms } from "../../redux/v2/program/actions";
import { GetWholeWorkoutByProgram, SetSelectedWorkout } from "../../redux/v2/workout/actions";

import { delay } from "../../utils";
import { ScreenType } from "../../utils/breakpoints";

import "./style.css";
import Upnext from "../workout/components/Upnext";
import ThumbnailWorkoutList from "../../common/Thumbnails/ThumbnailWorkoutList";

function ProgramDetail(props) {
    const navigate = useNavigate()

    const screenSize = ScreenType(useMediaQuery);

    const programID = new URLSearchParams(window.location.search).get("program");
    const levelID = new URLSearchParams(window.location.search).get("level");

    const { programs } = props.Program;
    const { groupedWorkouts, pendingWorkout } = props.Workout;
    const { account } = props.User;

    const [activeInfo, setActiveInfo] = useState("info");
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [programsLoaded, setProgramsLoaded] = useState(false);
    const [addingStatus, setAddingStatus] = useState(0); // 0 no, 1 loading, 2 success

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
        props.GetWholeWorkoutByProgram(programID, levelID ? levelID : null);
        props.GetAllWorkOutHistories();
        props.GetSelectionHistory();
        props.GetPrograms();
        props.GetAllWorkOutHistoriesWithArchived();
    }, [])

    useEffect(() => {
        if (programs?.length > 0 && programID != null) {
            let temp;

            temp = programs.filter(p => p.id == programID);
            setSelectedProgram(temp[0]);

            setProgramsLoaded(true);
        }
    }, [programs, programID])

    useEffect(() => {
        if (screenSize != "xl") {
            setActiveInfo("all");
        } else {
            setActiveInfo("info");
        }
    }, [screenSize, programID])

    useEffect(() => {
        let temp = account?.user?.selected_program?.split(",") || [];

        if (temp.includes(programID + (levelID ? ("-" + levelID) : ""))) {
            if (addingStatus == 0) {
                setAddingStatus(3);
            } else if (addingStatus == 2) {
                delay(() => {
                    setAddingStatus(3);
                }, 2000);
            }
        }
    }, [account?.user?.selected_program, addingStatus, groupedWorkouts]);


    const key = ("prog-" + programID) + (levelID ? ("-" + levelID) : "");
    const progWorkouts = groupedWorkouts[key] || [];

    const ActionButton = () => {
        return (
            <>
                {
                    (addingStatus == 0 || addingStatus == 1) &&
                    // true && 
                    <div id="pdab-back-btn" className="clickable" onClick={() => {
                        // setSelectedProgram(null);
                        if (progWorkouts.length) {
                            props.SetSelectedWorkout(progWorkouts[0]);
                            navigate("/workout?view-type=preview&workout=" + progWorkouts[0].id)
                        }
                    }}>
                        <div id="pdab-back-btn-wrapper">
                            <div className="btn-wrp">
                                <Dumbbell />
                            </div>
                            <h6>TRY IT</h6>
                        </div>
                    </div>
                }
                <div id="pdab-add-btn" style={(addingStatus != 0 && addingStatus != 1) ? { width: "100%" } : {}} className={((addingStatus == 2 || addingStatus == 3) && screenSize == "xl") ? "full-radius" : ""} onClick={async () => {
                    if (addingStatus == 0) {
                        setAddingStatus(1);
                        const res = await props.AddProgram(selectedProgram?.id, levelID);
                        if (res.success) {
                            delay(() => {
                                setAddingStatus(3);
                            }, 2000);
                            setAddingStatus(2);
                        } else {
                            setAddingStatus(0);
                            toast.error('Failed to add Program');
                        }
                    } else if (addingStatus == 3) {
                        if (progWorkouts.length) {
                            props.SetSelectedWorkout(progWorkouts[0]);
                            navigate("/workout?workout=" + progWorkouts[0].id)
                        }
                    }
                }}>

                    {
                        addingStatus == 0 &&
                        <div id="pdab-add-btn-wrapper" className="g-orange">
                            <div className="btn-wrp flex-c">
                                <div className="btn-cont">
                                    <FaPlus />
                                </div>
                            </div>
                            <h6>ADD PROGRAM</h6>
                        </div>
                    }

                    {
                        addingStatus == 1 && <div className="flex-c-full"> <LoadingAnimation2 /></div>
                    }

                    {
                        addingStatus == 2 &&
                        <div className="flex-c-full">
                            <AiOutlineCheckCircle style={{ fontSize: "35px" }} />
                        </div>
                    }

                    {
                        addingStatus == 3 &&
                        <div className="flex-c-full">
                            <h4>GET STARTED</h4>
                        </div>
                    }


                </div>
            </>
        )
    }

    let selectedProgramsKeys = account?.user?.selected_program?.split(",");
    const key2 = programID + (levelID && levelID != 0 ? ("-" + levelID) : "");
    const added = selectedProgramsKeys?.indexOf(key2) > -1 || false;

    return (
        <div id="program-intro-v2" className="program-detail content-area">
            <PaddedContentArea>
                {/* <CloseButton onClick={() => {
                    navigate(-1);
                }} /> */}
                <div id="onb-v2-program-details">
                    <div id="onb-v2-program-video">
                        <ProgramVideo selectedProgram={selectedProgram} screenSize={screenSize} />

                        {
                            programsLoaded &&
                            <div id="onb-v2-video-detail">
                                <div>
                                    {
                                        (activeInfo == "all" || activeInfo == "info") &&
                                        <ProgramDescription
                                            selectedProgram={{
                                                ...selectedProgram,
                                                level: levelID
                                            }}
                                            screenSize={screenSize}
                                            progWorkouts={progWorkouts}

                                            getStarted={addingStatus == 3 ? () => {
                                                if (progWorkouts.length) {
                                                    props.SetSelectedWorkout(progWorkouts[0]);
                                                    navigate("/workout?workout=" + progWorkouts[0].id)
                                                }
                                            } : null}

                                            actionAdd={addingStatus != 3 ? async () => {
                                                if (addingStatus == 0) {

                                                    const toastId = toast.loading("Adding Program...");

                                                    setAddingStatus(1);

                                                    const res = await props.AddProgram(selectedProgram?.id, levelID);
                                                    if (res.success) {
                                                        delay(() => {
                                                            setAddingStatus(3);
                                                        }, 2000);

                                                        toast.success('Program Added', {
                                                            id: toastId,
                                                        });
                                                        setAddingStatus(2);

                                                    } else {
                                                        setAddingStatus(0);
                                                        toast.error('Failed to add Program', {
                                                            id: toastId,
                                                        });

                                                    }
                                                }
                                            } : null}

                                            actionGoToWorkouts={() => {
                                                // setSelectedProgram(null);
                                                if (progWorkouts.length) {
                                                    props.SetSelectedWorkout(progWorkouts[0]);
                                                    navigate("/workout?view-type=preview&workout=" + progWorkouts[0].id)
                                                }
                                            }}
                                            actionGoToPrograms={() => {
                                                navigate("/programs")
                                            }}
                                        />
                                    }

                                    {
                                        (activeInfo == "all" || activeInfo == "supp") &&
                                        <ProgramEquipments selectedProgram={selectedProgram} />
                                    }

                                    {
                                        ((activeInfo == "all" || activeInfo == "supp") && screenSize != "xl") &&
                                        <Upnext program={programID} level={levelID || 0} workouts={progWorkouts || []} screenSize={screenSize} />
                                    }


                                </div>
                            </div>
                        }

                        {
                            !programsLoaded &&
                            <div style={{ width: "100%", marginTop: "50px" }} className="flex-c">
                                <LoadingAnimation />
                            </div>
                        }

                    </div>

                    {
                        (programsLoaded && addingStatus != 3) &&
                        // programsLoaded && !added &&
                        <div id="program-details-action-button">
                            <ActionButton />
                        </div>
                    }



                </div>

                {
                    screenSize == "xl" &&
                    <div id="onb-v2-program-details" className="onb-v2-program-details-clone">
                        <div id="program-videos-panel">
                            <h5>FULL PROGRAM</h5>
                            <ThumbnailWorkoutList content={progWorkouts || []} program={programID} level={levelID || 0} withDate={false} midView={2} smallView={1.6} orientation='y' screenSize={screenSize} />
                        </div>

                    </div>
                }

            </PaddedContentArea>
        </div>
    );
}


const mapStateToProps = (state) => ({
    Program: state.Program,
    Workout: state.Workout,
    User: state.User,
});

export default connect(mapStateToProps, {
    AddProgram,
    GetPrograms,
    GetWholeWorkoutByProgram,
    SetSelectedWorkout,
    GetAllWorkOutHistories,
    GetAllWorkOutHistoriesWithArchived,
    GetSelectionHistory,
})(ProgramDetail);